/**
 * 說明 : 電梯資料與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 新增電梯
export const addElevator = createAsyncThunk('elevator/addElevator', async (elevator, {getState, rejectWithValue}) => {
  try {
    const token = getState().auth.token;
    const data = await BaseAPI.postWithAuth('/elevMgmt/elevator', elevator, token);
    return data;
  } catch (err) {
    console.error('add elevator error', err.response.data);
    return rejectWithValue(err.response.data);
  }
});

// 修改電梯
export const editElevator = createAsyncThunk('elevator/editElevator', async (elevator, {getState, rejectWithValue}) => {
  try {
    const token = getState().auth.token;
    const data = await BaseAPI.putWithAuth('/elevMgmt/elevator', elevator, token);
    return data;
  } catch (err) {
    console.error('edit elevator error', err.response.data);
    return rejectWithValue(err.response.data);
  }
});

// 修改電梯狀態
export const editElevatorStatus = createAsyncThunk(
  'elevator/editElevatorStatus',
  async ({elevatorIds, status}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/elevMgmt/elevator/status', {elevatorIds: elevatorIds, flgStatus: status}, token);
      return data;
    } catch (err) {
      console.error('update elevator status error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得電梯大樓資料
export const fetchElevator = createAsyncThunk('elevator/fetchElevator', async (elevatorId, {getState, rejectWithValue}) => {
  try {
    const token = getState().auth.token;
    const data = await BaseAPI.getWithAuth(`/elevMgmt/elevator/${elevatorId}`, null, token);
    return data;
  } catch (err) {
    console.error('fetch elevator error', err.response.data);
    return rejectWithValue(err.response.data);
  }
});

// 取得專案清單列表
export const fetchElevatorList = createAsyncThunk(
  'elevator/fetchCaseList',
  async ({buildingId, elevatorName, elevatorId}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/case',
        {buildingId: buildingId, elevatorName: elevatorName, elevatorId: elevatorId},
        token,
      );
      return data;
    } catch (err) {
      //   console.error('fetch elevator list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得有效的電梯名稱選單
export const fetchElevatorSelection = createAsyncThunk('elevator/fetchElevatorSelection', async (_, {getState, rejectWithValue}) => {
  try {
    const token = getState().auth.token;
    const data = await BaseAPI.getWithAuth('/selection/elevator', null, token);
    return data;
  } catch (err) {
    console.error('fetch elevator selection error', err.response.data);
    return rejectWithValue(err.response.data);
  }
});
